import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FixedHeader from '@components/FixedHeader';
import MenuSearchInput from '@conversion/containers/MenuSearchInput';
import Tabs from '../../components/Tabs';

const Container = styled.div`
  box-shadow: ${({ theme }) => theme.commons.header.elevation};
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: end;
  flex: 1;
  height: 52px;
  margin-top: ${({ withMargin }) => withMargin && '12px'};
  background: ${({ theme }) => theme.colors.white};
  margin: ${({ theme }) => theme.spacing(0, 0, 0, 6)};
`;

const StyledTabsGroceries = styled(Tabs)`
  position: relative;
  top: 0;
  height: 40px;
  #swiper__element_tabs:first-child {
    margin-left: 12px;
  }
  box-shadow: ${({ theme }) => theme.commons.header.elevation};
`;

const StyledMenuSearchInput = styled(MenuSearchInput)`
  margin: ${({ theme }) => theme.spacing(2, 6, 0, 0)};
  width: 100%;
`;

function SecondHeaderGroceries({
  goBack,
  onFocusSearch,
  menuFilterSearch,
  onCancelSearch,
  onMenuFilterChange,
  menuSections,
  selectTab,
  selectedSection,
  subHeader,
  placeholder,
}) {
  return (
    <Container>
      <FixedHeader onClose={goBack} label="" showLogo shadow>
        <SearchContainer>
          <StyledMenuSearchInput
            isHeader
            onClick={onFocusSearch}
            value={menuFilterSearch}
            onCancel={onCancelSearch}
            onChange={onMenuFilterChange}
            placeholder={placeholder}
            autoFocus
          />
        </SearchContainer>
      </FixedHeader>
      <StyledTabsGroceries
        tabs={menuSections}
        onSelect={selectTab}
        tabSelectedId={selectedSection}
        swipeable
      />
      {subHeader}
    </Container>
  );
}

SecondHeaderGroceries.propTypes = {
  menuFilterSearch: PropTypes.string,
  menuSections: PropTypes.array,
  selectedSection: PropTypes.number,
  placeholder: PropTypes.string,

  subHeader: PropTypes.node,

  goBack: PropTypes.func.isRequired,
  selectTab: PropTypes.func.isRequired,
  onFocusSearch: PropTypes.func.isRequired,
  onCancelSearch: PropTypes.func.isRequired,
  onMenuFilterChange: PropTypes.func.isRequired,
};

export default SecondHeaderGroceries;
